import React, { FC, useMemo } from 'react';
import Svg from 'svg-inline-react';
import { Link } from 'react-router-dom';
import InfoSvg from '@src/svgs/fr-info-icon.svg';
import SuccessSvg from '@src/svgs/fr-success.svg';
import ErrorSvg from '@src/svgs/fr-error.svg';
import WarningSvg from '@src/svgs/fr-warning.svg';
import CloseSvg from '@src/svgs/fr-close.svg';
import { FlashMessageProps } from './props';
import './styles.scss';

export const FlashMessage: FC<FlashMessageProps> = ({ title, message, type, link, linkLabel, close, to }) => {
  const icon = useMemo(() => {
    switch (type) {
      case 'success':
        return SuccessSvg;
      case 'info':
        return InfoSvg;
      case 'warning':
        return WarningSvg;
      case 'error':
        return ErrorSvg;
      default:
        return null;
    }
  }, [type]);

  return (
    <div className="fr-flash-message">
      {icon && <Svg className="fr-flash-message__icon" src={icon} />}

      <div className="fr-flash-message__content">
        <span className="fr-flash-message__title">{title}</span>

        {message && <span className="fr-flash-message__message">{message}</span>}

        {linkLabel && !to && (
          <a className="fr-flash-message__link" href={link} onClick={linkLabel && close} target="_blank">
            {linkLabel || link}
          </a>
        )}

        {to && linkLabel && (
          <Link className="fr-flash-message__link" to={to}>
            {linkLabel}
          </Link>
        )}
      </div>

      <Svg className="fr-flash-message__close" onClick={close} src={CloseSvg} />
    </div>
  );
};
